// extracted by mini-css-extract-plugin
export var gif = "_hb-0";